import { mainZIndex } from '../../app/zIndex'

const renderTimeout = countdown => {
    const countdownContainer = document.getElementById('GUIDDE-JS-Countdown')
    const timer = countdownContainer?.firstElementChild
    const body = document.querySelector('body')

    if (countdown === 0) {
        countdownContainer?.remove()
    } else if (countdownContainer && timer) {
        timer.remove()
        timer.innerHTML = String(countdown)
        countdownContainer.appendChild(timer)
    } else {
        const newContainer = document.createElement('div')
        newContainer.id = 'GUIDDE-JS-Countdown'
        newContainer.className = 'Guidde_Countdown'
        newContainer.style.zIndex = String(mainZIndex)

        const content = document.createElement('div')
        content.innerHTML = countdown
        content.className = 'Guidde_ZoomIn'
        newContainer.appendChild(content)

        body?.appendChild(newContainer)
    }
}
export const startTimeout = () => {
    let counter = 3
    renderTimeout(counter)
    const intervalId = window.setInterval(() => {
        counter = counter - 1
        renderTimeout(counter)

        if (counter === 0) {
            window.clearInterval(intervalId)
        }
    }, 1000)
}
